import UserDetail from './user-detail';
import store from './user-store';
import routes from './user-routes';

const components = [UserDetail];

export default {
  components,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/user/user-module.js